import { Link, NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as Logo } from '@/assets/icons/logo.svg';
import Button from '@/components/Button';
import AuthModal from '@/components/Layout/AuthModal';
import Text from '@/components/Text';

const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 2;
  left: 0;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 20px 24px;
`;

const StyledLogo = styled(Logo)`
  height: 20px;
  width: auto;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const AuthHolder = styled.div`
  position: relative;
`;

const StyledNavLink = styled(NavLink)`
  color: ${({ theme }) => theme.colors.grayscaleDark};
  font-weight: 500;
  transition: all ease-out 0.2s;
  &:hover {
    ${Text} {
      color: ${({ theme }) => theme.colors.purple};
    }
  }
  &.active {
    ${Text} {
      color: ${({ theme }) => theme.colors.purple};
      text-decoration: underline;
    }
  }
`;

const VacationHeader = () => {
  return (
    <HeaderWrapper>
      <Link to="/">
        <StyledLogo />
      </Link>
      <Actions>
        <Button as={Link} to="/" color="colorized">
          Go to Backbone
        </Button>
        <StyledNavLink to="/general/freelancers/request-vacation">
          <Text as="span" $type="captionSemibold">
            Vacations
          </Text>
        </StyledNavLink>
        <StyledNavLink to="/general/freelancers/invoices">
          <Text as="span" $type="captionSemibold">
            Invoices
          </Text>
        </StyledNavLink>
      </Actions>
      <Actions>
        <AuthHolder>
          <AuthModal />
        </AuthHolder>
      </Actions>
    </HeaderWrapper>
  );
};

export default VacationHeader;
